export default {
  NODE_ENV: "staging",
  API_URL: "https://dev-api-tg.telphin.ru",
  TG_BOT_URL: "https://t.me/ShonovBot",
  MAX_BOT_URL: "https://max.ru/id7814466467_2_bot",
};
